import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ShipToHome: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--ship-to-home')}
    data-icon={icon}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="21"
    viewBox="0 0 205 200.29"
  >
    <g>
      <path d="M14.06 90.85L109.92 0 205 90.07l-190.94.78" />
      <path d="M177.13 200.29H41.8V88.34h135.33zm-48-67.46l-25.8-25.85-7.79 7.79 16.36 16.36H0v11h111.92l-16.39 16.43 7.79 7.79 25.76-25.79 3.73-4.08z" />
    </g>
  </svg>
);

export default ShipToHome;
